/*
 * 名刺情報入力用のmixin
 */
// import historykana from 'historykana'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const LibRepository = RepositoryFactory.get('lib')

export default {
  props: {
    // v-model
    value: {type: Object, required: true},
    isModelInitialized: {type: Boolean, required: true},
    fileViewMode: {type: Boolean, required: false, default: true},
    // 修正前データと比較するかどうか
    useCompare: {type: Boolean, requried: false, default: false},
    // 確認画面フラグ
    isModeConf: {type: Boolean, requried: false, default: false},
    // このエリアのタイトル
    areaTitle: {type: String, required: false, default: '<i class="fa fa-id-card-o fa-fw"></i> 名刺情報'},
    // 変更不可項目
    nochgFields: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    // 人物画像流用フラグ
    isClone: {type: Boolean, required: false, default: false}
    // useAutokana: {type: zBoolean, required: false, default: false}
  },
  data: function () {
    return {
      // backup
      blankBcard: {},
      // response backup
      originalBcard: {},
      // 元の入力値モーダル
      modalOriginalData_isOpen: false,
      modalOriginalData_item: {},
      // 画像流用フラグ
      useClonedImages: false,
      fileDropReloader: true,
      // // 自動かな変換
      // autoKanas: {
      //   last_name: {
      //     histories: []
      //   },
      //   first_name: {
      //     histories: []
      //   }
      // },
      maxlengths: {}
    }
  },
  methods: {
    isFieldView: function (field) {
      if (this.useCompare) {
        return this.isModeconf || this.fieldModes[field] !== 'edit'
      }
      else {
        return this.isModeConf || this.isIncludes(this.nochgFields, field)
      }
    },
    /**
     * | image mode || fileViewMode | isModeConf | useClonedImages | nochgFields['image'] |
     * |    edit    ||      x       |      x     |        x        |          x           |
     * |    conf    ||      *       |      o     |        x        |          x           |
     * |    view    ||      o       |      *     |        *        |          *           |
     * |    view    ||      *       |      *     |        o        |          *           |
     * |    view    ||      *       |      *     |        *        |          o           |
     */
    isImageEdit: function () {
      return !this.isImageConf() && !this.isImageView()
    },
    isImageConf: function () {
      return this.isModeConf && !this.useClonedImages && !this.isIncludes(this.nochgFields, 'image')
    },
    isImageView: function () {
      return (this.fileViewMode && !this.isModeConf) || this.useClonedImages || this.isIncludes(this.nochgFields, 'image')
    },
    /**
     * 名刺情報が変更されたかどうか
     * @param Array|String fields
     * @return Boolean
     */
    isFieldChanged: function (fields) {
      if (!this.useCompare) {
        return false
      }

      if (typeof fields === 'string') {
        fields = [fields]
      }

      const vm = this
      return fields.some(function (field) {
        return vm.value[field] !== vm.originalBcard[field]
      })
    },
    /**
     * 名刺情報の入力モードを変更する
     * @param String mode: edit/conf(default)
     * @param Array|String fields
     */
    changeFieldMode: function (mode, fields) {
      if (this.isModeConf) return // 確認画面では実行しない
      if (!this.useCompare) return // 流用画面以外では実行しない
      if (typeof fields === 'string') {
        fields = [fields]
      }
      for (let i = fields.length - 1; i >= 0; i--) {
        this.fieldModes[fields[i]] = mode
        // 入力値を元に戻す
        if (mode === 'conf') {
          let bcard = this.value
          bcard[fields[i]] = this.originalBcard[fields[i]]
          this.$emit('input', bcard)
        }
      }
      this.$forceUpdate()

      // 入力欄にカーソルを入れる
      if (mode === 'edit') {
        this.$nextTick(function () {
          document.getElementById(fields[0]).focus()
        })
      }
    },
    /**
     * 名刺情報の変更前データを表示する
     * @param String name: 表示名
     * @param Array|String fields
     */
    modalOriginalData_open: function (name, fields) {
      // if (!this.useCompare || !this.isModeConf) return
      if (typeof fields === 'string') {
        fields = [fields]
      }

      let items = {}
      for (let i = 0, len = fields.length; i < len; i++) {
        // items.push({key: fields[i], value: this.originalBcard[fields[i]]})
        items[fields[i]] = this.originalBcard[fields[i]]
      }
      this.modalOriginalData_item = {
        isOpen: true,
        name: name,
        items: items
      }

      // モーダルを開く
      this.modalOriginalData_isOpen = true
    },
    /*
     * 比較用に変更前データを保存しておく
     */
    _initOriginalBcard: function () {
      if (!this.useCompare) {
        return
      }
      for (let field in this.fieldModes) {
        this.originalBcard[field] = this.value[field]
      }
    },
    /**
     * 同一人物に名刺を追加時の各フィールドモードの設定
     */
    _initFieldModes: function () {
      let key
      // 編集画面の比較モードではフィールドごとに設定する
      if (!this.isModeConf && this.useCompare) {
        for (key in this.fieldModes) {
          if (this.value[key] !== this.originalBcard[key]) {
            this.fieldModes[key] = 'edit'
          }
          else {
            this.fieldModes[key] = 'conf'
          }
        }
      }
      // それ以外は画面のモードに従う
      else {
        const mode = this.isModeConf ? '' : 'edit'
        for (key in this.fieldModes) {
          this.fieldModes[key] = mode
        }
      }
    },
    /**
     * 画像流用切り替え
     */
    changeClonedFlag: function () {
      // 流用モードに切り替えるときは、元データに戻す
      if (this.useClonedImages) {
        this.changeFieldMode('conf', 'images')
      }
      // 編集モードに切り替えるときは、データを空にする
      else {
        this._updateValue('images', [])
      }

      const vm = this
      // 選択した画像を破棄するために、コンポーネント再読み込み
      this.fileDropReloader = false
      this.$nextTick(function () {
        vm.fileDropReloader = true
      })
    },
    /**
     * 自動入力フラグがONの場合のみ、自動入力する
     */
    onChangeName: function (e, nameField, kanaField) {
      // if (!this.useAutokana) {
      //   return
      // }
      // const nameValue = (e.target && e.target.value) || ''
      //
      // // 漢字変換の場合（safariで発生）
      // if (e.inputType === 'deleteCompositionText') {
      //   return
      // }
      //
      // if (nameValue.length === 0) {
      //   this.autoKanas[nameField].histories.splice(0)
      // }
      // else {
      //   this.autoKanas[nameField].histories.push(nameValue)
      // }
      //
      // this._updateValue(kanaField, historykana(this.autoKanas[nameField].histories))
    },
    /**
     * propsのvalueを更新する
     */
    _updateValue: function (key, data) {
      let value = this.value
      value[key] = data
      this.$emit('input', value)
    },
    /**
     * 郵便番号から住所の自動入力
     * @param String zipcode 郵便番号入力値
     * @param String addressFieldName 更新対象の住所フィールド名
     */
    setAddress: function (zipcode, addressFieldName) {
      const vm = this
      // 住所1に値がある場合は自動補完しない
      if (this.value[addressFieldName]) {
        return
      }
      // 郵便番号のフォーマットでない場合は自動補完しない
      if (!zipcode.match(/^[0-9０-９]{3}-?[0-9０-９]{4}$/)) {
        return
      }
      LibRepository.getZipAddress(zipcode)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            const data = vm.getApiData(response)
            if (!vm.value[addressFieldName]) {
              vm._updateValue(addressFieldName, data.data)
            }
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    /**
     * エラーが発生した入力欄に対する処理を行う
     * ※親コンポーネントから呼び出して使う
     */
    validationError: function () {
      if (this.isModeConf) return // 確認画面では実行しない

      // invalidな項目を取得する
      const invalids = this.$el.querySelectorAll('.invalid')
      const invalidNames = []

      // name属性の値を取得
      for (const input of invalids) {
        invalidNames.push(input.name)
      }

      // invalidな入力欄を入力状態にする
      this.changeFieldMode('edit', invalidNames)

      // type変更後でも.invalidを引き継ぐ
      this.$nextTick(function () {
        for (const name of invalidNames) {
          this.$el.querySelector(`[name="${name}"]`).classList.add('invalid')
        }
      })
    }
  },
  watch: {
    isModelInitialized: function (to, from) {
      if (to === true && from === false) {
        this._initOriginalBcard()
        this._initFieldModes()
      }
    },
    $route: function (to, from) {
      this._initFieldModes()
    }
    // isModeConf: function (to, from) {
    //   this._initFieldModes()
    // }
  },
  created: function () {
    // 人物流用時、デフォルトは「画像を流用する」
    this.useClonedImages = this.isClone
    this.maxlengths = this.loadMaxlengths('Bcards')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/addbcard.js